
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "Image",
      "Interview",
      "InterviewMessage",
      "InterviewRulesAnalysis",
      "InterviewerPersona",
      "Organization",
      "Study",
      "User"
    ]
  }
};
      export default result;
    